import { NgIf } from '@angular/common';
import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AvatarModule } from 'primeng/avatar';
import { DialogModule } from 'primeng/dialog';
import { Ripple } from 'primeng/ripple';
import { StyleClassModule } from 'primeng/styleclass';
import { User } from '../../../../core/models/user.model';
import { UsersService } from '../../../../core/services/users.service';
import { LogoutComponent } from '../../../../features/auth/logout/logout.component';

@Component({
  selector: 'app-profile-section',
  templateUrl: 'profile-section.component.html',
  styleUrl: 'profile-section.component.scss',
  standalone: true,
  imports: [
    NgIf,
    AvatarModule,
    DialogModule,
    Ripple,
    StyleClassModule,
    LogoutComponent,
  ],
})
export class ProfileSectionComponent implements OnInit {
  user: User;
  private destroyRef = inject(DestroyRef);
  private userService = inject(UsersService);

  constructor() {
    this.user = new User(null);
  }

  ngOnInit() {
    this.getUser();
  }

  private getUser() {
    this.userService
      .getUserProfile()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(user => {
        this.user = new User(user);
      });
  }
}
